import { SvgIconsMap } from '@toggle/design-system';

export const isValidIcon = (name: string): name is keyof typeof SvgIconsMap =>
  name in SvgIconsMap;
